import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router'
import _ from 'lodash'

import Msg from '../../i18n/Msg'

import SmartMenuList from './NavMenuList'

import { isDev } from '../../utils/env';

export default class SmartMenuItem extends React.Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  };

  render() {
    const { item, checks, clients, locations, cptTotal, isWorkLocationAssigned } = this.props;

    const title = !item.parent ?
      <span className="menu-item-parent"><Msg phrase={item.title}/></span> :
      <Msg phrase={item.title}/>;

      if (item.title === 'Review Request') {
        item.badge.label = cptTotal;
      }

    const badge = item.badge ? <span className={item.badge.class}>{item.badge.label || ''}</span> : null;
    const style = item.expanded ? { display: 'block' } : {};
    const classname = item.expanded ? 'expanded' : '';
    let childItems = item.items ? <SmartMenuList style={style} className={classname} items={item.items} checks={checks} clients={clients} locations={locations} cptTotal={cptTotal} /> : null;

    const icon = item.icon ? (
      item.counter ? <i className={item.icon}><em>{item.counter}</em></i> : <i className={item.icon}/>
    ) : null;

    const parentPathname = item.route;
    const currentPathname = this.context.router.getCurrentLocation().pathname;
    const isActive = currentPathname.indexOf(parentPathname) !== -1;

    const liClassName = (item.route && isActive) ? 'active' : '';

    let link = item.route ?
    <Link to={item.route} title={item.title} className={classname} activeClassName="active">
      {icon} {title} {badge}
    </Link> :
    <a href={item.href || '#'} onClick={this._handleClick} title={item.title}>
      {icon} {title} {badge}
    </a>;

    if (item.check && checks) {
      const routeChecks = item.check.split(' ');
      const passed = routeChecks.some(el => checks[el]);

      if (!passed) {
        return null;
      }
    }

    if (item.title === 'Service Request Manager' && checks.isExternalStakeholder && !isWorkLocationAssigned) {
        return null;
    }

    if (item.clients && !clients) {
      return null;
    }

    if (item.clients && !childItems && clients) {
      if (item.route === 'cow-client-dashboard' && clients.map(el => (el.name !== 'City of Westminster'))) {
        link = null;
      }
      if (item.route === 'pai-client-report' && clients.map(el => (el.name !== 'PAI'))) {
        link = null;
      }
      if (item.route === 'pmd-demo-client-report' && clients.map(el => (el.name !== 'PMD Demo'))) {
        link = null;
      }
      if (item.route === 'sonm-client-dashboard' && clients.map(el => (el.name !== 'State of New Mexico'))) {
        link = null;
      }
      if (item.route === 'ac-client-dashboard' && clients.map(el => (el.name !== 'Anderson County'))) {
        link = null;
      }
      if (item.route === 'conmb-client-dashboard' && clients.map(el => (el.name !== 'City of North Myrtle Beach'))) {
        link = null;
      }

      const clientsItems = clients.map(el => ({ _id: _.uniqueId('clients-'), title: el.name, route: `${item.route}/${el.name}` }));
      if (item.route === 'cow-client-dashboard') {
        const clientCOW = clientsItems.filter(el => el.title === 'City of Westminster');
        if (clientCOW.length > 0) {
          //childItems = <SmartMenuList style={style} className={classname} items={clientCOW} checks={checks} />;
          link = <Link to={item.route} title={item.title} className={classname} activeClassName="active">
            {icon} {title} {badge}
          </Link>;
        }
      }
      else if (item.route === 'sonm-client-dashboard') {
        const clientCOW = clientsItems.filter(el => el.title === 'State of New Mexico');
        if (clientCOW.length > 0) {
          //childItems = <SmartMenuList style={style} className={classname} items={clientCOW} checks={checks} />;
          link = <Link to={item.route} title={item.title} className={classname} activeClassName="active">
            {icon} {title} {badge}
          </Link>;
        }
      }
      else if (item.route === 'ac-client-dashboard') {
        const clientAC = clientsItems.filter(el => el.title === 'Anderson County');
        if (clientAC.length > 0) {
          //childItems = <SmartMenuList style={style} className={classname} items={clientAC} checks={checks} />;
          link = <Link to={item.route} title={item.title} className={classname} activeClassName="active">
            {icon} {title} {badge}
          </Link>;
        }
      }
      else if (item.route === 'conmb-client-dashboard') {
        const clientCONMB = clientsItems.filter(el => el.title === 'City of North Myrtle Beach');
        if (clientCONMB.length > 0) {
          //childItems = <SmartMenuList style={style} className={classname} items={clientCONMB} checks={checks} />;
          link = <Link to={item.route} title={item.title} className={classname} activeClassName="active">
            {icon} {title} {badge}
          </Link>;
        }
      }
      else if (item.route === 'pai-client-report') {
        const clientPAI = clientsItems.filter(el => el.title === 'PAI');
        if (clientPAI.length > 0) {
          childItems = <SmartMenuList style={style} className={classname} items={clientPAI} checks={checks} />;
          link = <a href={item.href || '#'} onClick={this._handleClick} title={item.title}>
            {icon} {title} {badge}
          </a>;
        }
      }
      else if (item.route === 'pmd-demo-client-report') {
        const clientPMDDemo = clientsItems.filter(el => el.title === 'PMD Demo');
        if (clientPMDDemo.length > 0) {
          childItems = <SmartMenuList style={style} className={classname} items={clientPMDDemo} checks={checks} />;
          link = <a href={item.href || '#'} onClick={this._handleClick} title={item.title}>
            {icon} {title} {badge}
          </a>;
        }
      }
      else {
        childItems = <SmartMenuList style={style} className={classname} items={clientsItems} checks={checks} />;
        link = <a href={item.href || '#'} onClick={this._handleClick} title={item.title}>
          {icon} {title} {badge}
        </a>;
      }
    }

    if (item.locations && !childItems && locations) {
      const locationsItems = locations.map(el => ({ _id: _.uniqueId('locations-'), title: el.name, route: `${item.route}/${el.name}` }));
      childItems = <SmartMenuList style={style} className={classname} items={locationsItems} checks={checks} />;
      link = <a href={item.href || '#'} onClick={this._handleClick} title={item.title}>
        {icon} {title} {badge}
      </a>;
    }

    if (item.dev && !isDev) {
      return null;
    }

    return <li className={liClassName}>{link}{childItems}</li>
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/components/NavMenuItem.js